import { FormControl, MenuItem, Select, SelectChangeEvent, IconButton } from '@mui/material';
import { BaseFieldWrapper } from './BaseFieldWrapper';
import { DropdownProperties } from 'src/api/process-module';
import { Field } from 'src/API';
import { TEST_IDS } from 'src/test-ids';
import ClearIcon from '@mui/icons-material/Clear';

interface DropdownFieldProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  fieldProps?: DropdownProperties;
}

export const DropdownField = ({ field, value, onChange, disabled = false, fieldProps }: DropdownFieldProps) => {
  const dataSource = (() => {
    const source = (field as any).properties?.dataSource || field.dataSource;
    if (!source) return [];
    try {
      const parsed = JSON.parse(source);
      return parsed;
    } catch (e) {
      console.error('Failed to parse dropdown dataSource:', e);
      return [];
    }
  })();
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <BaseFieldWrapper label={field.label} required={fieldProps?.required} fieldProps={fieldProps}>
      <FormControl fullWidth>
        <Select
          value={value || ''}
          onChange={handleChange}
          disabled={disabled}
          variant="outlined"
          displayEmpty
          defaultValue=""
          data-testid={TEST_IDS.DROPDOWN_FIELD_PREVIEW.SELECT}
          endAdornment={
            value ? (
              <IconButton
                size="small"
                sx={{ mr: 2 }}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange('');
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            ) : null
          }
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
          }}
          renderValue={(selected) => {
            if (!selected) {
              return <em>{fieldProps?.placeholder || 'Select an option'}</em>;
            }
            // Find the option with matching name to display its label
            const selectedOption = dataSource.find((opt: { name: string; label?: string }) => opt.name === selected);
            return selectedOption?.label || selected;
          }}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.12)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.24)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
          }}
          // placeholder="test"
          // placeholder={fieldProps?.placeholder || "Select an option"}
        >
          {dataSource.map((option: { name: string; label?: string }) => (
            <MenuItem
              key={option.name}
              value={option.name}
              sx={{
                py: 1.5,
                px: 2,
              }}
            >
              {option.label || option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </BaseFieldWrapper>
  );
};
